import React from 'react'
import TitleBar from '../../../header/components/TitleBar'
import { NavigationBar } from '../../../header/components/NavigationBar'
import AuthConsumer from '../../auth/AuthConsumer'
import AuthService from '../../auth/auth.service'
import { viewNames } from '../../globalConstants'

import './AppContainer.scss'
import { useLocation } from 'react-router-dom'

function AppContainer ({ children }) {
  const location = useLocation();

  return (
    <AuthConsumer>
      {({ user }) =>
        <React.Fragment>
          <TitleBar/>
          {AuthService.loginFinished(user, location) && <NavigationBar onboarding={location.pathname.includes(viewNames.ONBOARDING) || location.pathname.endsWith(viewNames.PROJECTS)}/>}
          {AuthService.loginFinished(user, location) ? children : null}
        </React.Fragment>
      }
    </AuthConsumer>
  )
}

export default AppContainer